import { createMuiTheme } from '@material-ui/core/styles'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#975ce6',
      contrastText: '#FFFFFF'
    },
    secondary: {
      main: '#975ce6'
    }
  }
})

export default theme
